// @ts-nocheck
import { USER_DETAILS_ERROR, USER_DETAILS_LOADING, USER_DETAILS_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';
import { isSessionExpiredRedirecting } from '../../config/common';

export const user_details = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: USER_DETAILS_LOADING,
                data: true
            })
            Authservices.user_details(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: USER_DETAILS_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
                // callApi reports a failed request to Support and returns undefined rather than throwing, so a
                // reply that is not a 200 is a failure: settle, or USER_DETAILS_LOADING and the callers' loaders never clear.
                // (Not while the user is already being sent to the login page: the page is going away and has said why.)
                if (isSessionExpiredRedirecting()) return;
                const message = 'An unexpected error has occurred and AvSight Support has been notified. Please reload the screen and try again.';
                dispatch({
                    type: USER_DETAILS_ERROR,
                    data: {message}
                })
                return reject({message});
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: USER_DETAILS_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}